import $ from 'jquery';
import config from '../app/config';

const Stepper = function () {
  this.el = false;
  this.opts = {
    stepsPositions: [],
    steps: false,
    imagePosition: 0,
    activeSlide: 0,
    endOfStepper: false,
    firstImage: null,
    bottomMargin: 0,
    stepperActive: false,
  };

  this.init = function (el) {
    this.el = el;
    this.opts.steps = this.el.find('.stepper__step');
    this.noTouch = $(document.documentElement).hasClass('no-touch');

    if (this.noTouch && config.desktop) {
      this.activateStepper();
    } else {
      this.stepperActive = false;
    }

    return this;
  };
};

Stepper.fn = Stepper.prototype;

Stepper.fn.setEvents = function () {
  $(window).on('scroll mousewheel DOMMouseScroll', e => {
    if (!this.opts.endOfStepper) {
      const $div = $('.stepper__wrap');
      const $parent = $div.parent();
      const scrollAmount = 30;
      const currentScroll = $parent.scrollTop();
      const eventDataRest = e.originalEvent.wheelDelta;
      const eventDataFirefix = e.originalEvent.detail;
      let newScroll;

      if (eventDataRest) {
        newScroll = currentScroll + (eventDataRest < 0 ? scrollAmount : -scrollAmount);
      } else {
        newScroll = currentScroll + (eventDataFirefix < 0 ? -scrollAmount : scrollAmount);
      }

      $parent.scrollTop(newScroll);

      this.calculateStuff();
      this.setActiveStep();
      this.checkEndOfStepper();

      return false;
    }
    this.restartStepper();

    return undefined;
  });

  $(window).on('resize', () => {
    if (this.resizing) {
      clearTimeout(this.resizing);
    }
    this.resizing = setTimeout(() => {
      if (!this.stepperActive && (this.noTouch || config.desktop)) {
        this.activateStepper();
      } else if (this.stepperActive && (!config.desktop || !this.noTouch)) {
        this.deactivateStepper();
      }

      if (this.noTouch && config.desktop) {
        this.calculateStuff();
        this.setMargins();
      }
    }, 500);
  });

  this.opts.steps.on('click', '', e => {
    if ($(e.target).is('a')) {
      return true;
    }
    if ($(e.target).parents('.stepper__step').hasClass('stepper__step--active')) {
      return false;
    }

    const activeStep = this.opts.steps.filter('.stepper__step--active');
    const activeStepOffset = activeStep.position().top;
    const anotherStep = $(e.target).parents('.stepper__step');
    const extraOffset = anotherStep.position().top;
    const $parent = $('.stepper__wrap').parent();
    const currentScrollTop = $parent.scrollTop();
    const direction = (activeStepOffset < extraOffset);

    $($parent).animate({
      scrollTop: direction ? currentScrollTop + activeStep.height() + 15 :
        currentScrollTop - anotherStep.height() - 15,
    }, 500, () => {
      this.calculateStuff();
      this.setActiveStep();
      this.checkEndOfStepper();
    });

    return undefined;
  });
};

Stepper.fn.activateStepper = function () {
  this.stepperActive = true;
  this.opts.steps.each(function () {
    $(this).find('.stepper__step-image').css('opacity', 0);
  });
  this.setup();
};

Stepper.fn.deactivateStepper = function () {
  $(window).off('scroll mousewheel DOMMouseScroll');
  this.opts.steps.first().css('margin-top', 0);
  this.opts.steps.last().css('margin-bottom', 0);
  this.opts.steps.each(function () {
    $(this).find('.stepper__step-image').css('opacity', 1);
  });
  this.stepperActive = false;
};

Stepper.fn.setActiveStep = function () {
  const tempArray = this.opts.stepsPositions.map(position => (position <= this.opts.imagePosition ? 1 : 0));

  const tempIndex = tempArray.lastIndexOf(1);

  if (tempIndex !== this.opts.activeSlide) {
    this.opts.steps
      .eq(this.opts.activeSlide)
      .removeClass('stepper__step--active')
      .find('.stepper__step-image')
      .delay(100)
      .animate({
        opacity: 0,
      });

    this.opts.activeSlide = tempIndex;

    this.opts.steps
      .eq(this.opts.activeSlide)
      .addClass('stepper__step--active')
      .find('.stepper__step-image')
      .animate({
        opacity: 1,
      });
  }
};

Stepper.fn.calculateStuff = function () {
  this.opts.imagePosition = this.opts.firstImage.offset().top + (this.opts.firstImage.height() / 2);
  this.opts.stepsPositions = [];
  this.opts.steps.each((index, element) => {
    this.opts.stepsPositions.push($(element).offset().top);
  });
};

Stepper.fn.setMargins = function () {
  // margines na górze żeby tekst był na wysokości połowy obrazka
  let marginTop = (this.opts.firstImage.height() / 2) - (this.opts.firstStep.height() / 2);

  if (marginTop < 0) {
    marginTop = 0;
  }

  this.opts.firstStep.css('margin-top', marginTop);

  // margines na ostatnim elemencie żeby po deojechaniu do końca był na wysokości połowy obrazka
  this.opts.bottomMargin = (this.el.height() / 2);
  this.opts.steps.last().css('margin-bottom', this.opts.bottomMargin);
};

Stepper.fn.checkEndOfStepper = function () {
  if (this.opts.stepsPositions[this.opts.steps.length - 1] < this.opts.imagePosition - 50) {
    this.opts.endOfStepper = true;
    this.el.css('overflow-y', 'hidden');
  }
};

Stepper.fn.restartStepper = function () {
  if ($(window).scrollTop() === 0) {
    this.opts.endOfStepper = false;
    this.el.css('overflow-y', 'auto');
  }
};

Stepper.fn.setup = function () {
  this.opts.firstStep = this.opts.steps.first();
  this.opts.firstImage = this.opts.firstStep.find('.stepper__step-image');

  this.opts.firstStep.addClass('stepper__step--active');
  this.opts.firstImage.css('opacity', 1);

  this.calculateStuff();

  this.setMargins();

  this.setEvents();
};

$.fn.stepper = function (obj) {
  return (new Stepper()).init($(this), obj);
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/plugins/stepper.js